export let POSTS: Array<any> = [
    {
      "id": 26208,
      "date": "2019-05-15T14:53:27",
      "date_gmt": "2019-05-15T14:53:27",
      "guid": {
        "rendered": "https://www.explorerstc.com/?p=26208"
      },
      "modified": "2019-07-09T16:04:11",
      "modified_gmt": "2019-07-09T16:04:11",
      "slug": "como-es-el-hotel-ideal",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2019/05/15/como-es-el-hotel-ideal/",
      "title": {
        "rendered": "¿Cómo es el hotel ideal?"
      },
      "content": {
        "rendered": "\n<blockquote class=\"wp-block-quote\"><p><em>Qué la estadía en un lugar siempre te haga sentir como en casa. </em></p><cite><em>Anónimo.</em></cite></blockquote>\n\n\n\n<p>Cuando por fin el viaje por el que has esperado esta tan cerca que casi puedes palparlo, lo único que esperas es que todo sea perfecto desde la compra de tiquetes hasta el regreso a casa. Sin embargo, en lo primero que piensas es en reservar el hotel. </p>\n\n\n\n<p>Y\naunque busques en millones de páginas de hoteles y hayas reservado el mejor de\ntodos, aquí te contamos las recomendaciones que debes tener en cuanta a la hora\nde buscar ese lugar donde definitivamente quieres sentirte como en casa. </p>\n\n\n\n<p>Piensa en el <strong><em>motivo principal de tu viaje</em></strong> de ahí depende todo, si viajas con tu pareja, con tus padres, de vacaciones, aventura, o vas por temas de trabajo asegúrate de buscar cualidades de hotel según tus necesidades, ¿Cómo crees que puedes tener wifi en un camping? </p>\n\n\n\n<p>Una vez el motivo, <strong><em>identifica el destino</em></strong> que quieres visitar y reserva el hotel con buena ubicación tanto al aeropuerto como a otras zonas comunes, si es playa con vista al mar, si es ciudad fría con aire acondicionado. Las opciones van variando y tu debes pensar en que tu estadía debe cubrir, en principio, todas tus necesidades básicas. </p>\n\n\n\n<p>En este punto, piensa en los restaurantes, el parque principal, la cercanía a la playa, bares o <strong><em>zonas de entretenimiento</em></strong>, te recomendamos&nbsp; que escojas muy bien el sitio en el que deseas descansar, aquí es importante que sepas que una cosa es tener la discoteca cerca para divertirte y otra querer dormir y no poder por el ruido que genera. </p>\n\n\n\n<p>Otra característica, es la <strong><em>conexión o desconexión</em></strong>, si tu viaje es negocios no puedes llevarte contigo la oficina en la maleta, es necesario que el hotel te preste servicios de conectividad, como cables, equipos, internet, entres otros. Pero, por otro lado, si quieres desconectarte por completo, busca un sitio con este tipo ser características. </p>\n\n\n\n<p>Es importante no elegir el mejor de todos los hoteles, si no el que este dispuesto a beneficiarte de acuerdo a tu viaje y tus acompañantes. En ese orden de ideas, <strong><em>revisa tus finanzas, haz cuentas, verifica una y otra vez</em></strong>, no queremos que tu viaje se convierta en un gasto a futuro. </p>\n\n\n\n<blockquote class=\"wp-block-quote\"><p><strong>Recuerda,</strong> <strong><em>el hotel perfecto es económico</em></strong><em>. ¡Cuidado!, económico no quiere decir que cueste menos en valor absoluto, quiere decir que&nbsp;cueste poco para todo lo que ofrece.</em></p></blockquote>\n\n\n\n<p>Y antes de dar el clic final de reserva, revisa en plataformas que tengan <strong><em>comentarios u opiniones</em></strong> y la calificación de lo huéspedes del hotel, en booking o tripadvisor encontrarás referencias, esto te ayudará a mejorar tu filtro y saber si estas tomando una buena decisión. </p>\n\n\n\n<p>Y la recomendación más importante, es que <strong><em>reserves con antelación</em></strong>, planea, programa y ejecuta, no queremos que a última hora en tu habitación en las Bahamas tengas que quedarte sin aire acondicionado. </p>\n\n\n\n<p>Y es todo, desde <a href=\"https://www.explorerstc.com\">Explorers Travelers Club</a>, te deseamos un buen viaje. &nbsp;</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>El viaje perfecto empieza con el hotel perfecto. Aquí aprendes a elegir el mejor. </p>\n",
        "protected": false
      },
      "author": 11,
      "featured_media": 26368,
      "comment_status": "closed",
      "ping_status": "open",
      "sticky": true,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        119
      ],
      "tags": [
        124,
        123
      ],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2019/05/5-Lugares-que-no-conoces-Explorers-copy-2.png",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26208"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/11"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=26208"
          }
        ],
        "version-history": [
          {
            "count": 15,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26208/revisions"
          }
        ],
        "predecessor-version": [
          {
            "id": 26383,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26208/revisions/26383"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/26368"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=26208"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=26208"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=26208"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 26205,
      "date": "2019-05-15T14:50:59",
      "date_gmt": "2019-05-15T14:50:59",
      "guid": {
        "rendered": "https://www.explorerstc.com/?p=26205"
      },
      "modified": "2019-07-09T23:23:51",
      "modified_gmt": "2019-07-09T23:23:51",
      "slug": "lorem-ipsum-dolor-sit-amet-2",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2019/05/15/lorem-ipsum-dolor-sit-amet-2/",
      "title": {
        "rendered": "¿Qué sitios visitar según tu personalidad?"
      },
      "content": {
        "rendered": "\n<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Aunque visitar todos los destinos puede resultarte interesante, tus gustos pueden definir tus lugares favoritos. Aquí encontrarás tu lugar favorito según tu personalidad</p>\n",
        "protected": false
      },
      "author": 8,
      "featured_media": 26381,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        119
      ],
      "tags": [],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2019/05/5-Lugares-que-no-conoces-Explorers.png",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26205"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/8"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=26205"
          }
        ],
        "version-history": [
          {
            "count": 5,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26205/revisions"
          }
        ],
        "predecessor-version": [
          {
            "id": 26398,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26205/revisions/26398"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/26381"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=26205"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=26205"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=26205"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 26203,
      "date": "2019-05-15T14:48:29",
      "date_gmt": "2019-05-15T14:48:29",
      "guid": {
        "rendered": "https://www.explorerstc.com/?p=26203"
      },
      "modified": "2019-07-24T22:56:43",
      "modified_gmt": "2019-07-24T22:56:43",
      "slug": "por-que-deberias-viajar",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2019/05/15/por-que-deberias-viajar/",
      "title": {
        "rendered": "¿Por qué deberías viajar?"
      },
      "content": {
        "rendered": "\n<p></p>\n\n\n\n<p>A los humanos les encanta viajar. Mental o físicamente, escapan a otros lugares. Anhelan la aventura. Buscan lo desconocido. Quieren ver nuevos lugares, aprender cosas nuevas, disfrutar de nuevas experiencias y luego regresar a sus hogares con lo familiar, lo seguro, antes de despegar nuevamente en sus viajes.</p>\n\n\n\n<p>Este comportamiento de partida-retorno tiene sus orígenes, las observaciones de los bebés muestran que, desde la base segura de tener un padre presente y disponible, el bebé se atreve a alejarse una distancia corta y luego regresar al padre, moverse un poco más lejos y regresar, hasta que en distancias incrementales y asombrosamente medibles explora el entorno que lo rodea y que tiene el coraje de ir más allá.</p>\n\n\n\n<p>Este puede ser el primer viaje simbólico: la primera salida,\nla primera expedición y el posible comienzo del error de viaje para aquellos\npara quienes su primer viaje independiente fue exitoso.</p>\n\n\n\n<p>Con estos primeros pasos independientes lejos de la presencia paterna se encuentra el deseo  recurrente de llegar más allá de los límites actuales del espacio y las relaciones.</p>\n\n\n\n<p>Y mira lo que está más lejos. Y aún más para ver lo que no se ve, lo que está a la vuelta de la esquina, en la habitación de al lado y, finalmente, en el otro lado de nuestro mundo geográfico o psicológico. Esta es una necesidad humana. Es por eso que hemos descubierto nuestro mundo, hemos viajado a lo largo, hemos caminado hasta la cima de sus montañas y la profundidad de sus océanos. Es por eso que nos sentimos descontentos con la exploración de nuestra propia planta, pero tuvimos que ir más allá hacia lo desconocido. Es por eso que, como nos recuerda el poeta TS Eliot, &#8220;no dejaremos de explorar&#8221;. </p>\n\n\n\n<p>Es nuestra naturaleza viajar. Es nuestra alegría viajar. Es\nnuestra disposición psicológica paradójica desear las condiciones\ncontradictorias de estabilidad y cambio: quedarse y ir, ser y explorar,\ndescansar y viajar sin cesar.</p>\n\n\n\n<p>Viajar es más que ir a alguna parte. Es un acontecimiento\npsicológico. Requiere motivación e imaginación. Comienza en la infancia con\nvacilantes primeros pasos y con imaginación encendida por los cuentos de\n&#8220;hace mucho, mucho tiempo en una tierra lejana&#8221;.</p>\n\n\n\n<p>Salimos de estas fantasías de la infancia decididas a cruzar\nlos océanos, a encontrar esas tierras lejanas, los personajes que contienen y\nla magia que poseen. Decididos a encontrar las aventuras que prometen y la posibilidad\nde regresar a casa triunfantes con trofeos, habiendo vencido todo miedo,\nsuperando todos los obstáculos y viviendo felices todos los días.</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>A los humanos les encanta viajar. Mental o físicamente, escapan a otros lugares. Anhelan la aventura. Buscan lo desconocido. Quieren&#8230;</p>\n",
        "protected": false
      },
      "author": 8,
      "featured_media": 26416,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        119
      ],
      "tags": [],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2019/05/Porque-viajar-explorers.png",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26203"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/8"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=26203"
          }
        ],
        "version-history": [
          {
            "count": 5,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26203/revisions"
          }
        ],
        "predecessor-version": [
          {
            "id": 26418,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26203/revisions/26418"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/26416"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=26203"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=26203"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=26203"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 26197,
      "date": "2019-05-15T14:46:35",
      "date_gmt": "2019-05-15T14:46:35",
      "guid": {
        "rendered": "https://www.explorerstc.com/?p=26197"
      },
      "modified": "2019-07-31T22:23:07",
      "modified_gmt": "2019-07-31T22:23:07",
      "slug": "disfruta-de-cartagena-sin-pensar-en-mas",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2019/05/15/disfruta-de-cartagena-sin-pensar-en-mas/",
      "title": {
        "rendered": "Disfruta de Cartagena, sin pensar en más."
      },
      "content": {
        "rendered": "\n<blockquote class=\"wp-block-quote\"><p>Realmente amo estar en Cartagena; porque soy de allá ¿comprende?&nbsp;</p><cite>Gabriel García Márquez</cite></blockquote>\n\n\n\n<p>La\nciudad portuaria del caribe colombiano más conocida como la “Heroica”, es uno\nde los sitios de mayor concentración turística del país, según el informe de la\nCámara de Comercio de Cartagena de Indias en Enero a Mayo de 2018 se recibieron\naprox. 1,140,321 turistas nacionales e internacionales, incrementando el\nturismo nacional en un 32 por ciento. &nbsp;</p>\n\n\n\n<p>Sus\ncalles coloniales y sus playas de encanto hacen de esta ciudad un hermoso\nparaje turístico apalancado por su romanticismo y su arquitectura dominante. Y\nlo mejor de todo y aunque parezca imposible puedes disfrutar de su magia sin\ngastarte un centavo de más. </p>\n\n\n\n<p>En\nExplorers Travelers Club, queremos contarte los planes que puedes hacer\ncompletamente gratis.&nbsp; </p>\n\n\n\n<ul><li><strong>Salir a\ncaminar.</strong> Un paseo por el malecón y observar el muelle de los Pegasos,&nbsp; el callejón de los Mártires y el portal de\nlos dulces puede ser el inicio de tu gran aventura, allí podrás ver el Galeón\nbucanero, barco restaurante enorme de la ciudad</li><li>Visita ¡Por favor!&nbsp; <strong>la\ntorre del reloj,</strong> uno de los sitios más icónicos de Cartagena, no olvides\npasar por la <strong>Plaza de Aduana, </strong>que te\nrecomendamos recorrer con la mayor calma posible. </li><li>Como lugar imperdible la <strong>Catedral de Santa Catalina de Alejandría</strong>, es una de las iglesias\nmás antiguas del continente y cuenta con imágenes y marquesinas cubiertas en\noro. </li><li>Y para conocer la vida local de las personas y\nla fiesta urbana, date un paseo por la <strong>Plaza\nSanto Domingo</strong>, encontraras algunos espectáculos para tu diversión. </li><li>Si quieres conocer la historia precolombina de\nCartagena, visita el <strong>Museo del oro Zenù</strong>,\nque hace parte de la red de cultura del Banco de la Republica y la entrada es completamente\ngratuita. </li><li>Y si lo tuyo es brisa, sol y arena, te\nrecomendamos darte un buen chapuzón en las playas de Bocagrande, te aseguramos\nque valdrá mla pena. </li></ul>\n\n\n\n<p>Al final del día te invitamos a que conozcas la ciudad colonial, sus luces tenues y la magia que engalana las noches de esta hermosa ciudad. &nbsp;</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Cartagena, tiene tanto que contarte y tanto por hacer que el dinero no puede detenerte. </p>\n",
        "protected": false
      },
      "author": 11,
      "featured_media": 26432,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        119
      ],
      "tags": [],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2019/05/5-Lugares-que-no-conoces-Explorers-1.png",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26197"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/11"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=26197"
          }
        ],
        "version-history": [
          {
            "count": 7,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26197/revisions"
          }
        ],
        "predecessor-version": [
          {
            "id": 26434,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/26197/revisions/26434"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/26432"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=26197"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=26197"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=26197"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 1,
      "date": "2017-11-15T20:15:50",
      "date_gmt": "2017-11-15T20:15:50",
      "guid": {
        "rendered": "http://www.explorerstc.com/?p=1"
      },
      "modified": "2017-11-15T20:15:50",
      "modified_gmt": "2017-11-15T20:15:50",
      "slug": "hello-world",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2017/11/15/hello-world/",
      "title": {
        "rendered": "Hello world!"
      },
      "content": {
        "rendered": "<p>Welcome to <a href=\"https://wp.ghlink.com/\">Network</a>. This is your first post. Edit or delete it, then start blogging!</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Welcome to Network. This is your first post. Edit or delete it, then start blogging!</p>\n",
        "protected": false
      },
      "author": 4,
      "featured_media": 0,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        1
      ],
      "tags": [],
      "jetpack_featured_media_url": "",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/1"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/4"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=1"
          }
        ],
        "version-history": [
          {
            "count": 0,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/1/revisions"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=1"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=1"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=1"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 22768,
      "date": "2016-04-22T12:10:48",
      "date_gmt": "2016-04-22T12:10:48",
      "guid": {
        "rendered": "http://democontent.codex-themes.com/thegem-architecture/?p=22768"
      },
      "modified": "2016-04-22T12:10:48",
      "modified_gmt": "2016-04-22T12:10:48",
      "slug": "organizing-your-workspace-2",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2016/04/22/organizing-your-workspace-2/",
      "title": {
        "rendered": "Organizing Your Workspace (Demo)"
      },
      "content": {
        "rendered": "<p>[vc_row][vc_column css=&#8221;.vc_custom_1457791968195{margin-top: -18px !important;}&#8221;]<div class=\"gem-youtube gem-wrapbox gem-wrapbox-style-no-style rounded-corners gem-wrapbox-position-below\" style=\"width: 100%;\"><div class=\"gem-wrapbox-inner gem-ratio-style\" style=\"padding-top: 56.25%\"><iframe class=\"gem-wrapbox-element img-responsive\" width=\"100%\" height=\"300\" allowfullscreen=\"allowfullscreen\" frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" src=\"//www.youtube.com/embed/XovcSDRQRO4?rel=0&amp;wmode=opaque\"></iframe></div></div><div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 25px;\"></div>[/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.[/vc_column_text]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 35px;\"></div><div   class=\"gem-quote gem-quote-style-2 gem-quote-no-paddings\"><blockquote  >&#8230;Lorem Ipsum proin gravida nibh vel velit  aliquet.</blockquote></div><div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: -32px;\"></div>[vc_column_text]orem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 20px;\"></div>[/vc_column][/vc_row][vc_row][vc_column]<div class=\"gem-textbox\" ><div class=\"gem-textbox-inner\" style=\"border: 3px solid #e3e8ea;\"><div class=\"gem-textbox-content\" style=\"background-position: center top;\"><div class=\"gem-alert-box\"><div class=\"gem-alert-inner\"><div class=\"gem-alert-box-picture\"><div class=\"gem-icon gem-icon-pack-material gem-icon-size-medium  gem-icon-shape-circle\" style=\"border-color: #00bcd4;opacity: 1;\"><div class=\"gem-icon-inner\" style=\"\"><span class=\"gem-icon-half-1\" style=\"color: #00bcd4;\"><span class=\"back-angle\">&#xf412;</span></span><span class=\"gem-icon-half-2\" style=\"color: #00bcd4;\"><span class=\"back-angle\">&#xf412;</span></span></div></div></div><div class=\"gem-alert-box-content\">[vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris[/vc_column_text]</div><div class=\"gem-alert-box-buttons\"><div class=\"gem-button-container gem-button-position-center\"><a class=\"gem-button gem-button-size-medium gem-button-style-outline gem-button-text-weight-normal gem-button-border-2\" style=\"border-radius: 3px;border-color: #8697ff;color: #8697ff;\" onmouseleave=\"this.style.borderColor='#8697ff';this.style.backgroundColor='transparent';this.style.color='#8697ff';\" onmouseenter=\"this.style.backgroundColor='#8697ff';this.style.color='#ffffff';\" href=\"\" target=\"_self\">buy now</a></div> </div></div></div></div></div></div>[/vc_column][/vc_row]</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor,</p>\n",
        "protected": false
      },
      "author": 3,
      "featured_media": 23754,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        38
      ],
      "tags": [
        9,
        10,
        12
      ],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2016/04/dummy-post-horisontal.jpg",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22768"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/3"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=22768"
          }
        ],
        "version-history": [
          {
            "count": 0,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22768/revisions"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/23754"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=22768"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=22768"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=22768"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 22767,
      "date": "2016-04-22T12:09:25",
      "date_gmt": "2016-04-22T12:09:25",
      "guid": {
        "rendered": "http://democontent.codex-themes.com/thegem-architecture/?p=22767"
      },
      "modified": "2016-04-22T12:09:25",
      "modified_gmt": "2016-04-22T12:09:25",
      "slug": "the-newest-part-of-team-2",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2016/04/22/the-newest-part-of-team-2/",
      "title": {
        "rendered": "The Newest Part of Team (Demo)"
      },
      "content": {
        "rendered": "<p>[vc_row equal_height=&#8221;yes&#8221; css=&#8221;.vc_custom_1457788806421{margin-top: -18px !important;margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788634484{margin-left: 0px !important;padding-bottom: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/5-6.jpg?id=9893) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788641047{margin-right: 0px !important;padding-bottom: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/15.jpg?id=9913) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][/vc_row][vc_row equal_height=&#8221;yes&#8221; css=&#8221;.vc_custom_1457788064361{margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788029212{background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/1-18.jpg?id=11923) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 25px;\"></div><div class=\"centered-box\"><div class=\"gem-icon gem-icon-pack-material gem-icon-size-medium  gem-icon-shape-circle\" style=\"border-color: rgba(135,123,228,0.34);border-color: rgba(84,79,135,0.18);opacity: 1;\"><div class=\"gem-icon-inner\" style=\"background-color: rgba(135,123,228,0.34);\"><span class=\"gem-icon-half-1\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf398;</span></span><span class=\"gem-icon-half-2\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf398;</span></span></div></div></div><div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 25px;\"></div>[vc_column_text]</p>\n<div class=\"title-h4\" style=\"text-align: center;\"><span style=\"color: #ffffff;\">dolor ipsum</span><br />\n<span style=\"color: #ffffff;\">dolor sit amet</span></div>\n<p>[/vc_column_text][vc_column_text]</p>\n<div style=\"text-align: center;\"><span style=\"color: #ffffff;\">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788645891{padding-top: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/3-7.jpg?id=9889) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][/vc_row][vc_row][vc_column]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 46px;\"></div>[vc_column_text]Lorem ipsum dolor sit amet, consectetur adi pisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.[/vc_column_text]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 40px;\"></div>[/vc_column][/vc_row][vc_row][vc_column]<div   class=\"gem-quote gem-quote-style-4 gem-quote-no-paddings\"><blockquote  >&#8230;Lorem Ipsum proin gravida nibh vel velit auctor aliquet lorem quis bibendum auctor, nisi elit</blockquote></div>[/vc_column][/vc_row][vc_row css=&#8221;.vc_custom_1457788607747{margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788989575{padding-bottom: 404px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/13-1.jpg?id=9909) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788939445{padding-bottom: 20px !important;padding-left: 42px !important;}&#8221; offset=&#8221;vc_col-lg-offset-0&#8243;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi.[/vc_column_text][/vc_column][/vc_row][vc_row css=&#8221;.vc_custom_1457788581707{margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457789015745{padding-top: 33px !important;padding-right: 42px !important;}&#8221;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi.[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788951975{padding-bottom: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/1-8.jpg?id=9885) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][/vc_row]</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris.</p>\n",
        "protected": false
      },
      "author": 3,
      "featured_media": 23754,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        38
      ],
      "tags": [
        9,
        10,
        12
      ],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2016/04/dummy-post-horisontal.jpg",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22767"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/3"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=22767"
          }
        ],
        "version-history": [
          {
            "count": 0,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22767/revisions"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/23754"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=22767"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=22767"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=22767"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 22766,
      "date": "2016-04-22T12:07:50",
      "date_gmt": "2016-04-22T12:07:50",
      "guid": {
        "rendered": "http://democontent.codex-themes.com/thegem-architecture/?p=22766"
      },
      "modified": "2016-04-22T12:07:50",
      "modified_gmt": "2016-04-22T12:07:50",
      "slug": "easy-to-use-gallery-system-2",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2016/04/22/easy-to-use-gallery-system-2/",
      "title": {
        "rendered": "Easy To Use Gallery System (Demo)"
      },
      "content": {
        "rendered": "<p>[vc_row][vc_column css=&#8221;.vc_custom_1457791968195{margin-top: -18px !important;}&#8221;]<div class=\"gem-youtube gem-wrapbox gem-wrapbox-style-no-style rounded-corners gem-wrapbox-position-below\" style=\"width: 100%;\"><div class=\"gem-wrapbox-inner gem-ratio-style\" style=\"padding-top: 56.25%\"><iframe class=\"gem-wrapbox-element img-responsive\" width=\"100%\" height=\"300\" allowfullscreen=\"allowfullscreen\" frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" src=\"//www.youtube.com/embed/XovcSDRQRO4?rel=0&amp;wmode=opaque\"></iframe></div></div><div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 25px;\"></div>[/vc_column][/vc_row][vc_row][vc_column width=&#8221;1/2&#8243;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.[/vc_column_text]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 35px;\"></div><div   class=\"gem-quote gem-quote-style-2 gem-quote-no-paddings\"><blockquote  >&#8230;Lorem Ipsum proin gravida nibh vel velit  aliquet.</blockquote></div><div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: -32px;\"></div>[vc_column_text]orem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.[/vc_column_text][/vc_column][/vc_row][vc_row][vc_column]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 20px;\"></div>[/vc_column][/vc_row][vc_row][vc_column]<div class=\"gem-textbox\" ><div class=\"gem-textbox-inner\" style=\"border: 3px solid #e3e8ea;\"><div class=\"gem-textbox-content\" style=\"background-position: center top;\"><div class=\"gem-alert-box\"><div class=\"gem-alert-inner\"><div class=\"gem-alert-box-picture\"><div class=\"gem-icon gem-icon-pack-material gem-icon-size-medium  gem-icon-shape-circle\" style=\"border-color: #00bcd4;opacity: 1;\"><div class=\"gem-icon-inner\" style=\"\"><span class=\"gem-icon-half-1\" style=\"color: #00bcd4;\"><span class=\"back-angle\">&#xf412;</span></span><span class=\"gem-icon-half-2\" style=\"color: #00bcd4;\"><span class=\"back-angle\">&#xf412;</span></span></div></div></div><div class=\"gem-alert-box-content\">[vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris[/vc_column_text]</div><div class=\"gem-alert-box-buttons\"><div class=\"gem-button-container gem-button-position-center\"><a class=\"gem-button gem-button-size-medium gem-button-style-outline gem-button-text-weight-normal gem-button-border-2\" style=\"border-radius: 3px;border-color: #8697ff;color: #8697ff;\" onmouseleave=\"this.style.borderColor='#8697ff';this.style.backgroundColor='transparent';this.style.color='#8697ff';\" onmouseenter=\"this.style.backgroundColor='#8697ff';this.style.color='#ffffff';\" href=\"\" target=\"_self\">buy now</a></div> </div></div></div></div></div></div>[/vc_column][/vc_row]</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris.</p>\n",
        "protected": false
      },
      "author": 3,
      "featured_media": 23754,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        38
      ],
      "tags": [
        9,
        10,
        12
      ],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2016/04/dummy-post-horisontal.jpg",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22766"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/3"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=22766"
          }
        ],
        "version-history": [
          {
            "count": 0,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22766/revisions"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/23754"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=22766"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=22766"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=22766"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 22104,
      "date": "2016-04-20T12:21:14",
      "date_gmt": "2016-04-20T12:21:14",
      "guid": {
        "rendered": "http://democontent.codex-themes.com/thegem-architecture/?p=22104"
      },
      "modified": "2016-04-20T12:21:14",
      "modified_gmt": "2016-04-20T12:21:14",
      "slug": "donec-volutpat-scelerisque-felis-quis-tristique-velit-ultrices-sit",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2016/04/20/donec-volutpat-scelerisque-felis-quis-tristique-velit-ultrices-sit/",
      "title": {
        "rendered": "Donec volutpat scelerisque felis, quis tristique velit ultrices sit amet. (Demo)"
      },
      "content": {
        "rendered": "<p>[vc_row equal_height=&#8221;yes&#8221; css=&#8221;.vc_custom_1457788806421{margin-top: -18px !important;margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788634484{margin-left: 0px !important;padding-bottom: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/5-6.jpg?id=9893) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788641047{margin-right: 0px !important;padding-bottom: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/15.jpg?id=9913) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][/vc_row][vc_row equal_height=&#8221;yes&#8221; css=&#8221;.vc_custom_1457788064361{margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788029212{background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/1-18.jpg?id=11923) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 25px;\"></div><div class=\"centered-box\"><div class=\"gem-icon gem-icon-pack-material gem-icon-size-medium  gem-icon-shape-circle\" style=\"border-color: rgba(135,123,228,0.34);border-color: rgba(84,79,135,0.18);opacity: 1;\"><div class=\"gem-icon-inner\" style=\"background-color: rgba(135,123,228,0.34);\"><span class=\"gem-icon-half-1\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf398;</span></span><span class=\"gem-icon-half-2\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf398;</span></span></div></div></div><div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 25px;\"></div>[vc_column_text]</p>\n<div class=\"title-h4\" style=\"text-align: center;\"><span style=\"color: #ffffff;\">dolor ipsum</span><br />\n<span style=\"color: #ffffff;\">dolor sit amet</span></div>\n<p>[/vc_column_text][vc_column_text]</p>\n<div style=\"text-align: center;\"><span style=\"color: #ffffff;\">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></div>\n<p>[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788645891{padding-top: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/3-7.jpg?id=9889) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][/vc_row][vc_row][vc_column]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 46px;\"></div>[vc_column_text]Lorem ipsum dolor sit amet, consectetur adi pisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.[/vc_column_text]<div class=\"clearboth\"></div><div class=\"gem-divider \" style=\"margin-top: 40px;\"></div>[/vc_column][/vc_row][vc_row][vc_column]<div   class=\"gem-quote gem-quote-style-4 gem-quote-no-paddings\"><blockquote  >&#8230;Lorem Ipsum proin gravida nibh vel velit auctor aliquet lorem quis bibendum auctor, nisi elit</blockquote></div>[/vc_column][/vc_row][vc_row css=&#8221;.vc_custom_1457788607747{margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788989575{padding-bottom: 404px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/13-1.jpg?id=9909) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788939445{padding-bottom: 20px !important;padding-left: 42px !important;}&#8221; offset=&#8221;vc_col-lg-offset-0&#8243;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi.[/vc_column_text][/vc_column][/vc_row][vc_row css=&#8221;.vc_custom_1457788581707{margin-right: 0px !important;margin-bottom: 0px !important;margin-left: 0px !important;}&#8221;][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457789015745{padding-top: 33px !important;padding-right: 42px !important;}&#8221;][vc_column_text]Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi.[/vc_column_text][/vc_column][vc_column width=&#8221;1/2&#8243; css=&#8221;.vc_custom_1457788951975{padding-bottom: 400px !important;background-image: url(https://www.explorerstc.com//wp-content/uploads/sites/4/2016/03/1-8.jpg?id=9885) !important;background-position: center !important;background-repeat: no-repeat !important;background-size: cover !important;}&#8221;][/vc_column][/vc_row]</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.</p>\n",
        "protected": false
      },
      "author": 3,
      "featured_media": 23754,
      "comment_status": "open",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        37
      ],
      "tags": [
        9,
        10,
        12
      ],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2016/04/dummy-post-horisontal.jpg",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22104"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/3"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=22104"
          }
        ],
        "version-history": [
          {
            "count": 0,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22104/revisions"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/23754"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=22104"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=22104"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=22104"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    },
    {
      "id": 22103,
      "date": "2016-04-20T12:21:13",
      "date_gmt": "2016-04-20T12:21:13",
      "guid": {
        "rendered": "http://democontent.codex-themes.com/thegem-architecture/?p=22103"
      },
      "modified": "2016-04-20T12:21:13",
      "modified_gmt": "2016-04-20T12:21:13",
      "slug": "nullam-vitae-blandit-odio-maecenas-at-mollis-ipsum",
      "status": "publish",
      "type": "post",
      "link": "https://www.explorerstc.com/2016/04/20/nullam-vitae-blandit-odio-maecenas-at-mollis-ipsum/",
      "title": {
        "rendered": "Nullam vitae blandit odio. Maecenas at mollis ipsum. (Demo)"
      },
      "content": {
        "rendered": "<p>[vc_row full_width=&#8221;stretch_row_content&#8221;][vc_column width=&#8221;1/4&#8243;]<div   class=\"gem-quote gem-quote-style-1 gem-quote-no-paddings\"><blockquote  >&#8230;Lorem ipsum dolor sit amet, consectetur adi pisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</blockquote></div>[/vc_column][vc_column width=&#8221;1/4&#8243;]<div class=\"gem-icon-with-text gem-icon-with-text-icon-size-medium gem-icon-with-text-flow\"><div style=\"margin-bottom:0px;margin-top:0px; \" class=\"gem-icon-with-text-icon\"><div class=\"gem-icon gem-icon-pack-material gem-icon-size-medium  gem-icon-shape-square\" style=\"border-color: #00bcd4;opacity: 1;\"><div class=\"gem-icon-inner\" style=\"background-color: #00bcd4;\"><span class=\"gem-icon-half-1\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf1be;</span></span><span class=\"gem-icon-half-2\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf1be;</span></span></div></div></div><div class=\"gem-icon-with-text-content\" ><div class=\"gem-icon-with-text-text\">[vc_column_text]psum dolor sit amet, consectetur adi pisicing elit, sed do eiusmod tempor inci didunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.[/vc_column_text]</div></div><div class=\"clearboth\"></div></div>[/vc_column][vc_column width=&#8221;1/4&#8243;]<div class=\"gem-icon-with-text gem-icon-with-text-icon-size-medium gem-icon-with-text-flow\"><div style=\"margin-bottom:0px;margin-top:0px; \" class=\"gem-icon-with-text-icon\"><div class=\"gem-icon gem-icon-pack-material gem-icon-size-medium  gem-icon-shape-square\" style=\"border-color: #00cab0;opacity: 1;\"><div class=\"gem-icon-inner\" style=\"background-color: #00cab0;\"><span class=\"gem-icon-half-1\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf287;</span></span><span class=\"gem-icon-half-2\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf287;</span></span></div></div></div><div class=\"gem-icon-with-text-content\" ><div class=\"gem-icon-with-text-text\">[vc_column_text]psum dolor sit amet, consectetur adi pisicing elit, sed do eiusmod tempor inci didunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.[/vc_column_text]</div></div><div class=\"clearboth\"></div></div>[/vc_column][vc_column width=&#8221;1/4&#8243;]<div class=\"gem-icon-with-text gem-icon-with-text-icon-size-medium gem-icon-with-text-flow\"><div style=\"margin-bottom:0px;margin-top:0px; \" class=\"gem-icon-with-text-icon\"><div class=\"gem-icon gem-icon-pack-material gem-icon-size-medium  gem-icon-shape-square\" style=\"border-color: #7e57c2;opacity: 1;\"><div class=\"gem-icon-inner\" style=\"background-color: #7e57c2;\"><span class=\"gem-icon-half-1\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf2ff;</span></span><span class=\"gem-icon-half-2\" style=\"color: #ffffff;\"><span class=\"back-angle\">&#xf2ff;</span></span></div></div></div><div class=\"gem-icon-with-text-content\" ><div class=\"gem-icon-with-text-text\">[vc_column_text]psum dolor sit amet, consectetur adi pisicing elit, sed do eiusmod tempor inci didunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.[/vc_column_text]</div></div><div class=\"clearboth\"></div></div>[/vc_column][/vc_row][vc_row][vc_column]<div class=\"preloader\"><div class=\"preloader-spin\"></div></div>\n<div class=\"gallery-preloader-wrapper\"> </div>[/vc_column][/vc_row]</p>\n",
        "protected": false
      },
      "excerpt": {
        "rendered": "<p>Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.</p>\n",
        "protected": false
      },
      "author": 3,
      "featured_media": 23754,
      "comment_status": "closed",
      "ping_status": "open",
      "sticky": false,
      "template": "",
      "format": "standard",
      "meta": [],
      "categories": [
        37
      ],
      "tags": [
        2,
        4,
        6
      ],
      "jetpack_featured_media_url": "https://www.explorerstc.com/wp-content/uploads/sites/4/2016/04/dummy-post-horisontal.jpg",
      "_links": {
        "self": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22103"
          }
        ],
        "collection": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts"
          }
        ],
        "about": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/types/post"
          }
        ],
        "author": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/users/3"
          }
        ],
        "replies": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/comments?post=22103"
          }
        ],
        "version-history": [
          {
            "count": 0,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/posts/22103/revisions"
          }
        ],
        "wp:featuredmedia": [
          {
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media/23754"
          }
        ],
        "wp:attachment": [
          {
            "href": "https://www.explorerstc.com/wp-json/wp/v2/media?parent=22103"
          }
        ],
        "wp:term": [
          {
            "taxonomy": "category",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/categories?post=22103"
          },
          {
            "taxonomy": "post_tag",
            "embeddable": true,
            "href": "https://www.explorerstc.com/wp-json/wp/v2/tags?post=22103"
          }
        ],
        "curies": [
          {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
          }
        ]
      }
    }
  ];